import React from 'react';

/**
 * Адаптивний фрейм модуля, який динамічно підлаштовується під будь-які розміри.
 * Малює кутові дужки як в оригінальному фреймі.
 */
const AdaptiveFrameRenderer = ({ 
  width, 
  height, 
  scale = 1,
  strokeColor = "#000000",
  strokeWidth = 1,
  cornerSize = null,
  dashArray = "5,3"
}) => {
  // Автоматичний розрахунок розміру кутів базуючись на розмірі модуля
  const autoCornerSize = Math.min(width, height) * 0.06;
  const corner = cornerSize || Math.max(autoCornerSize, 6);
  
  // Товщина ліній
  const lineWidth = Math.max(0.8, strokeWidth);
  
  // Відступ від краю
  const offset = 1;

  return (
    <g className="adaptive-frame" style={{ pointerEvents: 'none' }}>
      {/* Пунктирний периметр (тонкий, як в оригіналі) */}
      <rect
        x={offset}
        y={offset}
        width={width - offset * 2}
        height={height - offset * 2}
        fill="none"
        stroke="rgba(107, 114, 128, 0.7)"
        strokeWidth={lineWidth * 0.5}
        strokeDasharray={dashArray}
      />
      
      {/* Кутові дужки - верхній лівий */}
      <path
        d={`M ${offset} ${offset + corner} L ${offset} ${offset} L ${offset + corner} ${offset}`}
        fill="none"
        stroke={strokeColor}
        strokeWidth={lineWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Кутові дужки - верхній правий */}
      <path
        d={`M ${width - offset - corner} ${offset} L ${width - offset} ${offset} L ${width - offset} ${offset + corner}`}
        fill="none"
        stroke={strokeColor}
        strokeWidth={lineWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Кутові дужки - нижній правий */}
      <path
        d={`M ${width - offset} ${height - offset - corner} L ${width - offset} ${height - offset} L ${width - offset - corner} ${height - offset}`}
        fill="none"
        stroke={strokeColor}
        strokeWidth={lineWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Кутові дужки - нижній лівий */}
      <path
        d={`M ${offset + corner} ${height - offset} L ${offset} ${height - offset} L ${offset} ${height - offset - corner}`}
        fill="none"
        stroke={strokeColor}
        strokeWidth={lineWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export default AdaptiveFrameRenderer;

